<template>
  <div class="input-group">
    <span class="input-group-text">filter as</span>
    <select class="form-select" v-model="currentFilter" @change="changedFilter">
      <optgroup
        v-for="(group, name) of filterGroups"
        :label="setFilterName(name)"
        :key="name"
      >
        <option
          v-for="filter of group"
          :value="setFilterValue(name, filter.id)"
          :key="filter.id"
        >
          {{ filter.name }}
        </option>
      </optgroup>
    </select>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'filter-as',
  props: {
    challenges: {
      type: Array,
      default: [],
    },
    lists: {
      type: Array,
      default: [],
    },
  },
  computed: {
    ...mapGetters('usercardio', ['filter']),
    current: {
      get() {
        return this.week
      },
      set(value) {},
    },
    currentFilter: {
      get() {
        let _data = null
        if (this.filter) {
          _data = this.filter.filterAs
        }
        console.log('Current Filter', _data)
        return _data
      },
      set(value) {
        console.log('Setting Current Filter', value)
        this.setFilter({
          name: 'filterAs',
          value: value,
        })
      },
    },
    filterGroups() {
      let _data = {
        first: [],
        second: [],
        third: [],
      }
      _data.first.push({
        id: -3,
        name: 'all',
      })
      _data.first.push({
        id: -4,
        name: 'new',
      })
      _data.first.push({
        id: -1,
        name: 'star',
      })
      _data.first.push({
        id: -2,
        name: 'nonstar',
      })
      if (this.challenges) {
        this.challenges.forEach((challenge) => {
          _data.second.push({
            id: challenge.id,
            name: challenge.name,
          })
        })
      }
      if (this.lists) {
        this.lists.forEach((list) => {
          _data.third.push({
            id: list.id,
            name: list.name,
          })
        })
      }
      return _data
    },
  },
  methods: {
    ...mapActions('usercardio', ['setFilter', 'setPager']),
    setFilterName(name) {
      let _data = 'Default'
      if (name === 'second') {
        _data = 'Your Challenges'
      } else if (name === 'third') {
        _data = 'Your Client Lists'
      }
      return _data
    },
    setFilterValue(name, id) {
      let _data = id
      if (name === 'second') {
        _data = `challenge_${id}`
      } else if (name === 'third') {
        _data = `user_list_${id}`
      }
      return _data
    },
    changedFilter() {
      this.setPager({
        name: 'page',
        value: 1,
      })
    },
  },
}
</script>
<style lang="scss" scoped>
</style>
